<template>
  <div class="d-print-none">
    <b-navbar class="nav-top-border" toggleable="lg">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-navbar-brand href="#">
        <m-a :href="{name:'Home'}">
          <b-img :src="findAttributeOnSiteInfo('icon')[0]" height="130"/>
        </m-a>
      </b-navbar-brand>

      <b-collapse id="nav-collapse" class="justify-content-center" is-nav>
        <b-navbar-nav class="mr-4" v-for="menu in storeMenus" :key="menu.id" v-if="menu.position === 'store_nav'">
          <NavMenuItem v-for="item in menu.children" :item="item" :key="item.id"/>
        </b-navbar-nav>
        <b-navbar-nav class="text-center align-items-center mr-auto">

          <b-nav-item class="nav-link p-1 text-white" :to="{ name: 'Login' }" v-if="!isAuth">
            <b-btn variant="primary" pill> ورود / عضویت</b-btn>
          </b-nav-item>
          <b-nav-item class="nav-link p-1 text-white" :to="{ name: 'Dashboard' }" v-else>
            <b-btn variant="primary" pill> ورود به داشبورد</b-btn>
          </b-nav-item>
          <m-search-input-1/>
          <slot/>
          <div v-if="shoppingCart">
            <b-nav-item v-if="isAuth  || findAttributeOnSiteInfo('cartType') == 1"
                        class="nav-link p-1 twxt-white"
                        :to="{ name: 'ShoppingCart' }"
            >
              <b-btn
                  variant="secondary"
                  class="d-flex align-items-center position-relative"
                  pill
              >
                <b-icon icon="cart-fill"></b-icon>
                <div v-if="isAuth" class="badge badge-primary order-items rounded-pill">
                <span v-if=" orderCount.length != 0 && orderCount.items != undefined">{{
                    orderCount.items.length
                  }}</span>
                </div>
              </b-btn>
            </b-nav-item>
            <b-nav-item v-else
                        class="nav-link p-1 twxt-white"
                        :to="{ name: 'UnAuthenticatedShoppingCart' }">
              <b-btn
                  variant="secondary"
                  class="d-flex align-items-center position-relative"
                  pill>
                <b-icon icon="cart-fill"></b-icon>
                <div class="badge badge-primary order-items rounded-pill">
                  {{ shoppingCartCount }}
                </div>
              </b-btn>
            </b-nav-item>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import NavMenuItem from "./NavMenuItem";

export default {
  name: "Nav1",
  props: {
    shoppingCart: {
      default: true,
    }
  },
  components: {NavMenuItem},
  data() {
    return {
      categoryShow: false,
      shoppingCartCount: 0
    };
  },
  methods: {
    countItemsOnUnAuthenticatedShoppingCart() {
      const localProducts = localStorage.products;
      this.shoppingCartCount = localProducts != undefined ? Object.keys(JSON.parse(localStorage.products)).length : 0;
    }
  },
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getStoreMenus",
      isAuth: "User/isAuthenticated",
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
  },
  async mounted() {
    if (this.shoppingCart) {
      if (this.isAuth) {
        await this.$store.dispatch("ShoppingCart/userOrderUnpaid");
      }
      window.addEventListener('DOMContentLoaded', this.countItemsOnUnAuthenticatedShoppingCart);
      window.addEventListener('click', this.countItemsOnUnAuthenticatedShoppingCart);
    }
  },
};
</script>

<style scoped>
.nav-logo {
  height: 60px;
}

.navbar-brand img {
  height: 45px;
}
</style>